export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11313.e1158453.jpg";